import { render, staticRenderFns } from "./FriendRequests.vue?vue&type=template&id=88aff9ca&"
import script from "./FriendRequests.vue?vue&type=script&lang=js&"
export * from "./FriendRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports